export const domain = process.env.REACT_APP_AUTH0_DOMAIN;
export const secret = process.env.REACT_APP_AUTH0_SECRET;
export const REACT_APP_SWING_API_URL = process.env.REACT_APP_SWING_API_URL;
export const REACT_APP_FLAGSMITH_ENVIRONMENT_ID = process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_ID;
export const REACT_APP_FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
export const REACT_APP_FACEBOOK_APP_VERSION = process.env.REACT_APP_FACEBOOK_APP_VERSION;
